module.exports = __webpack_public_path__ + "img/matchTask.7246c620.png";